import { post } from '@/utils/request'

export function getList(data) {
    return post('admin/banner/list', data)
}
export function getAdd(data) {
    return post('admin/banner/add', data)
}
export function getDel(data) {
    return post('admin/banner/del', data)
}
export function getEdit(data) {
    return post('admin/banner/editState', data)
}

